<template>
  <div id="appointment-checkout" style="height: 100%">
    <!-- <div id="checkout" style="height: calc(100% - 35px)"> -->
    <!-- <h1 class="text-center font-normal">Checkout Detail</h1>
    <vs-divider class="mb-0"></vs-divider>-->

    <div class="lg:flex h-full">
      <div class="lg:w-2/3 w-full flex flex-col align-center position-relative">
        <div
          class="w-full overflow-auto flex flex-col align-center left-responsive"
          style="background: #f7f7f8; height: calc(100vh - 93px)"
        >
          <div
            class="w-full pt-6 px-base"
            style="height: calc(100% - 235px); overflow-y: auto; overflow-x: hidden"
          >
            <!-- <div class="w-full pt-6 px-base"> -->
            <div class="flex position-relative mb-4">
              <datepicker
                id="edit-checkout-datepicker"
                :format="customFormatter"
                ref="datepicker"
                class="font-bold"
                style="padding: 2px; z-index: 90001;"
                v-model="datePicked"
              ></datepicker>
              <div class="flex align-center date-content font-extrabold">
                <span>{{customFormatter(datePicked)}}</span>
                <span
                  class="inline-block ml-2"
                  v-if="appointment_arr.length != 0"
                >({{appointment_arr[0].start_time}})</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="w-5 stroke-current ml-2" />
              </div>
            </div>
            <div v-for="(item, index) in appointment_arr" :key="index" class="pb-6">
              <vx-card class="cursor-pointer" @click="itemToShow = index">
                <div class="flex">
                  <div class="vx-col w-1/12 flex justify-center font-bold text-lg">{{index + 1}}</div>
                  <div class="w-11/12 pr-3">
                    <div class="flex justify-between">
                      <div>
                        <div class="font-bold text-xl" v-if="item.service">
                          {{item.service.name}}
                          <span
                            v-if="item.employee"
                            class="font-normal text-base"
                          >
                            with
                            <span class="text-primary">{{item.employee.name}}</span>
                          </span>
                        </div>
                        <!-- <div class="text-grey-custom text-sm">
                          <span class="text-primary">{{item.start_time}}</span> to
                          <span class="text-primary">{{item.end_time}}</span>
                          with
                          <span class="text-primary" v-if="item.employee">{{item.employee.name}}</span>
                        </div>-->
                      </div>
                      <div class="flex align-start">
                        ${{parseFloat(item.price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}
                        <feather-icon
                          icon="XIcon"
                          svgClasses="w-5 h-5 stroke-current text-danger ml-4"
                          style="margin-top: 2px"
                          @click.stop="removeLine(index)"
                        />
                      </div>
                    </div>
                    <transition name="list">
                      <div class="mt-base" v-if="itemToShow == index">
                        <div class="flex mb-4">
                          <div class="w-full">
                            <label class="text-sm">Service</label>
                            <v-select
                              label="name"
                              @input="selectService($event, index)"
                              class="w-full"
                              :options="services"
                              v-model="item.service"
                              :clearable="false"
                              :searchable="false"
                              @click="getTotal"
                            ></v-select>
                          </div>
                          <!-- <div class="w-1/2"></div> -->
                        </div>
                        <div class="flex">
                          <div class="w-1/2 mr-6">
                            <label class="text-sm">Price</label>
                            <vs-input
                              @input="changePrice($event,index)"
                              icon="attach_money"
                              class="w-full"
                              :maxlength="9"
                              v-model="item.price"
                              v-on:keypress="isNumber($event)"
                            />
                          </div>
                          <div class="w-1/2">
                            <label class="text-sm">Staff</label>
                            <v-select
                              label="name"
                              @input="selectStaff($event, index)"
                              class="w-full"
                              :options="staffs"
                              v-model="item.employee"
                              :clearable="false"
                              :searchable="false"
                            ></v-select>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <div class="w-full px-base">
            <div class="flex p-6 text-normal">
              <div class="w-1/2">
                <a
                  class="text-hover-underline flex align-center cursor-pointer"
                  @click="addService"
                >
                  <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 stroke-current text-primary" />Add more service
                </a>
              </div>
              <div class="w-1/2">
                <div class="flex justify-between pr-2">
                  <div>Total</div>
                  <div
                    v-if="current.length >=1"
                  >${{parseFloat(current).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                  <div v-else>$0</div>
                </div>

                <vs-divider class="mb-0"></vs-divider>
                <div class="py-3 pb-4" style="height: 116px; overflow: auto">
                  <a
                    class="text-hover-underline flex align-center my-2 cursor-pointer"
                    @click="popupAddTip"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 stroke-current text-primary" />Add tip
                  </a>

                  <!-- <a
                    class="text-hover-underline flex align-center my-2 cursor-pointer"
                    @click="popupPromotion"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 stroke-current text-primary" />Add promotion
                  </a>-->

                  <!-- <div v-if="this.promotion_added.checked == true">
                                      <div class="flex justify-between pl-2 pr-1" v-if="promotion_added.type=='percent'">
                                         <div @click="removePromo"><feather-icon icon="XIcon" svgClasses="h-4 w-4 stroke-current text-danger cursor-pointer"/></div>
                                        <div class="ellipsis">{{promotion_added.content}}</div>
                                        <div>- {{promotion_added.value}}%</div>
                                      </div>
                                      <div class="flex justify-between pl-2 pr-1" v-if="promotion_added.type=='usd'">
                                          <div @click="removePromo"><feather-icon icon="XIcon" svgClasses="h-4 w-4 stroke-current text-danger cursor-pointer"/></div>
                                          <div class="ellipsis">{{promotion_added.content}}</div>
                                          <div>- ${{promotion_added.value}}</div>
                                      </div>
                  </div>-->

                  <!-- <a
                    class="text-hover-underline flex align-center my-2 cursor-pointer"
                    @click="popupRedemtion"
                  >
                    <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 stroke-current text-primary" />Add redemption
                  </a>-->

                  <!-- <div v-for="(redem,index) in redemtion_added" :key="index">
                                      <div class="flex justify-between pl-2 pr-1" v-if="redem.checked == true">
                                        <div @click="removeRedem(redem)"><feather-icon icon="XIcon" svgClasses="h-4 w-4 stroke-current text-danger cursor-pointer"/></div>
                                        <div class="ellipsis">{{redem.content}}</div>
                                        <div>- ${{redem.value}}</div>
                                      </div>
                  </div>-->
                </div>
                <vs-divider class="mt-0"></vs-divider>

                <div class="flex align-center justify-between font-semibold text-2xl">
                  <div>Balance</div>
                  <div
                    v-if="current.length >=1"
                  >${{reCalculator().toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                  <div v-else>$0</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:w-1/3 lg:pt-0 pt-5 w-full h-full position-relative border-left-custom">
        <div>
          <div class="w-full" v-if="first_appointment.customer">
            <div class="flex justify-between align-center pb-4">
              <div class="flex align-center">
                <vs-avatar
                  :text="StringHelper.changeFormatAvatar(first_appointment.customer.full_name)"
                  size="60px"
                  class="mx-5 my-0 text-4xl"
                />
                <div>
                  <div class="flex font-bold text-lg justify-between">
                    <div class="mr-3 customer-name">{{first_appointment.customer.full_name}}</div>
                    <vs-alert
                      color="success"
                      class="flex align-center justify-center text-sm"
                      style="width: 70px; height: 25px !important"
                    >New</vs-alert>
                  </div>
                  <div class="text-grey-custom text-sm mt-2">
                    <feather-icon icon="PhoneIcon" svgClasses="h-3 w-3 mr-1" />
                    <span>{{StringHelper.phoneNumberFormat(first_appointment.customer.phone, true)}}</span>
                  </div>
                </div>
              </div>
              <feather-icon
                icon="ChevronRightIcon"
                svgClasses="h-5 w-5 stroke-current cursor-pointer"
                @click.stop="changeStatus"
                v-show="!showInfo"
              />
              <feather-icon
                icon="ChevronLeftIcon"
                svgClasses="h-5 w-5 stroke-current cursor-pointer"
                @click.stop="changeStatus"
                v-show="showInfo"
              />
            </div>
          </div>
        </div>

        <div
          class="position-relative"
          :class="{'border-top-custom' : showInfo}"
          style="height: calc(100vh - 168px); overflow: auto"
        >
          <div
            class="w-full h-full overflow-hidden"
            v-show="!showInfo"
            v-if="first_appointment.customer"
          >
            <div class="mb-4">
              <div class="vx-row mx-5">
                <div class="vx-col w-1/2 mb-2 p-0">
                  <div class="text-sm text-grey-custom">Points</div>
                  <p class="text-normal p-0">0 Pts</p>
                </div>
                <div class="vx-col w-1/2 mb-2 p-0">
                  <div class="text-sm text-grey-custom">Visit</div>
                  <p
                    class="text-normal p-0"
                    v-if="first_appointment.customer.visit_count > 1"
                  >{{first_appointment.customer.visit_count + ' times'}}</p>
                  <p v-else>{{first_appointment.customer.visit_count + ' time'}}</p>
                </div>
                <div class="vx-col w-1/full mb-2 p-0">
                  <div class="text-sm text-grey-custom">Check in</div>
                  <p class="text-normal p-0">20/10/2019 22:09</p>
                </div>
              </div>
              <div class="flex mx-5 align-center cursor-pointer" @click="popupNote = true">
                <div
                  class="flex align-center text-sm break-word p-0 text-grey-custom"
                  style="height: 35px"
                >
                  <span class="text-underline font-semibold" style="font-style: italic">
                    <em>Note:</em>
                  </span>
                  <div
                    class="text-grey-custom ml-2 break-word note"
                    style="font-style: italic; width: 210px;"
                    v-if="appointment_arr.length > 0"
                  >{{first_appointment.customer.note}}</div>
                  <!-- <div class="text-grey-custom ml-2 break-word note" style="font-style: italic; width: calc(100% - 45px);">{{appointmentDetail.customer.note}}</div> -->
                </div>
                <div class="ml-auto">
                  <i
                    class="material-icons ml-auto cursor-pointer bg-success text-white user-select-none edit-icon"
                  >create</i>
                </div>
              </div>

              <vs-popup
                class="checkout-popup-note"
                title="Note"
                :active.sync="popupNote"
                style="z-index: 90001"
              >
                <div class="pt-4">
                  <vs-textarea v-model="note" height="200" />
                  <btn-custom @click="saveNote">Save</btn-custom>
                </div>
              </vs-popup>
            </div>
            <vs-divider class="m-0"></vs-divider>
            <div
              class="flex flex-col align-center w-full calculator pl-5"
              style="height: calc(100vh - 367px); overflow: auto"
              v-on:keyup.delete="deleteNum(number)"
            >
              <div class="w-full position-relative" v-if="current.length >=1">
                <span class="text-4xl flex justify-center pt-3 pb-2">${{current}}</span>
                <!-- <div class="text-2xl" style="position: absolute; top: 50%; right: 20px; transform: translateY(-50%)">USD</div> -->
              </div>
              <div class="w-full position-relative" v-else>
                <span class="text-4xl flex justify-center pt-3 pb-2">$0</span>
                <!-- <div class="text-2xl" style="position: absolute; top: 50%; right: 20px; transform: translateY(-50%)">USD</div> -->
              </div>
              <div class="vx-row border-top-custom py-3 mx-0" style="width: 276px;">
                <div class="p-2 px-4 flex justify-center" v-for="num in 9" :key="num">
                  <!-- <vs-button type="border" class="text-4xl p-5 m-0 cal-button rounded-full" :value="num">{{num}}</vs-button> -->
                  <btn-custom
                    type="border"
                    class="text-4xl p-5 py-3 m-0 cal-button rounded-full"
                    :value="num"
                    v-on:click="append(num)"
                  >{{num}}</btn-custom>
                </div>
                <div class="p-2 px-4 flex justify-center">
                  <!-- <vs-button type="border" class="text-4xl p-5 m-0 font-bold cal-button rounded-full" value="10" @click="dot">.</vs-button> -->
                  <btn-custom
                    type="border"
                    class="text-4xl p-5 py-3 m-0 font-bold cal-button rounded-full"
                    value="10"
                    @click="dot"
                  >.</btn-custom>
                </div>
                <div class="p-2 px-4 flex justify-center">
                  <!-- <vs-button type="border" class="text-4xl p-5 m-0 cal-button rounded-full" value="0" @click="append('0')">0</vs-button> -->
                  <btn-custom
                    type="border"
                    class="text-4xl p-5 py-3 m-0 cal-button rounded-full"
                    value="0"
                    @click="append('0')"
                  >0</btn-custom>
                </div>
                <div class="p-2 px-4 flex justify-center">
                  <btn-custom
                    type="border"
                    class="p-5 py-3 m-0 cal-button rounded-full"
                    style="height: 62px"
                    v-on:click="deleteNum(number)"
                  >
                    <i class="material-icons pt-1 pr-1" style="font-size: 1.7rem">backspace</i>
                  </btn-custom>
                </div>
              </div>
            </div>

            <div
              class="flex flex-col align-center pt-4 pb-1 border-top-custom w-full pl-base pr-4"
              style="position:absolute; bottom: 0; left: 0;"
            >
              <!-- <vs-button color="dark" type="filled" class="font-bold shadow-m">CHECKOUT</vs-button> -->
              <vs-button
                class="font-bold gradient gradient-primary no-shadow w-full"
                v-if="appointment_arr.length == 0 || (appointment_arr.length != 0 && appointment_arr[0].service == null)"
                disabled
              >CHECKOUT</vs-button>
              <vs-button
                class="font-bold gradient gradient-primary no-shadow w-full"
                v-else
                @click="checkout"
              >CHECKOUT</vs-button>
            </div>
          </div>
          <transition name="list">
            <div class="w-full h-full pt-1" v-show="showInfo">
              <vs-tabs :color="colorx" style="background: #fff">
                <vs-tab @click="colorx = 'primary'" label="tab 1">
                  <div class="con-tab-ejemplo p-6">fdzsfdszfdz</div>
                </vs-tab>

                <vs-tab @click="colorx = 'success'" label="tab 2">
                  <div class="con-tab-ejemplo p-6">sdfzsfzsfzsfd</div>
                </vs-tab>

                <vs-tab @click="colorx = 'warning'" label="tab 3">
                  <div class="con-tab-ejemplo p-6">sdfzsfzsfzsfd</div>
                </vs-tab>

                <vs-tab @click="colorx = 'dark'" label="tab 4">
                  <div class="con-tab-ejemplo p-6">sdfzsfzsfzsfd</div>
                </vs-tab>
              </vs-tabs>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import vSelect from "vue-select";
import { StringHelper } from "../models/string_helper";
export default {
  name: "vs-checkout",
  components: {
    Datepicker,
    "v-select": vSelect
  },
  props: {
    appointmentDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    let appointment_arr = [];
    let datePicked = new Date();
    let note = "";
    let first_appointment = {};
    if (this.appointmentDetail) {
      appointment_arr.push({
        id: this.appointmentDetail.id,
        start_time: this.appointmentDetail.start_time,
        end_time: this.appointmentDetail.end_time,
        date: this.appointmentDetail.date,
        duration: this.appointmentDetail.duration,
        service: this.appointmentDetail.service,
        employee: this.appointmentDetail.employee,
        customer: this.appointmentDetail.customer,
        status: this.appointmentDetail.status,
        price_final: this.appointmentDetail.price_final,
        note: this.appointmentDetail.note,
        additional_appointments: this.appointmentDetail.additional_appointments,
        created_at: this.appointmentDetail.created_at,
        updated_at: this.appointmentDetail.updated_at
      });
      // console.log(appointment_arr);
      first_appointment = appointment_arr[0];

      appointment_arr[0].price =
        appointment_arr[0].service.price != null
          ? appointment_arr[0].service.price
          : 0;
      for (
        let i = 0;
        i < this.appointmentDetail.additional_appointments.length;
        i++
      ) {
        appointment_arr.push(this.appointmentDetail.additional_appointments[i]);
        appointment_arr[appointment_arr.length - 1].price =
          appointment_arr[appointment_arr.length - 1].service.price != null
            ? appointment_arr[appointment_arr.length - 1].service.price
            : 0;
      }
      this.datePicked = this.appointmentDetail.date;
      if (this.appointmentDetail.customer != null){
        this.note = this.appointmentDetail.customer.note;
      }
    }
    let current = 0;
    for (let i = 0; i < appointment_arr.length; i++) {
      current = current + parseFloat(appointment_arr[i].price);
    }
    current = current.toString();
    return {
      first_appointment,
      StringHelper,
      datePicked,
      appointment_arr,
      input_price: "",
      currentPage: 1,
      itemsPerPage: 10,
      currentPageStaff: 1,
      itemsPerPageStaff: 10,
      colorx: "primary",
      promotion_added: {},
      redemtion_added: [],
      current,
      number: "0",
      promotion: "",
      itemToShow: {},
      note,
      popupNote: false,
      showInfo: false,
      popupConfigPromotion: {
        isOpen: false
      },
      popupConfigRedemtion: {
        isOpen: false
      },
      popupService: {
        isOpen: false
      },
      popupTip: {
        isOpen: false
      }
    };
  },
  methods: {
    changePrice(event, index) {
      if (!isNaN(parseFloat(event))) {
        this.appointment_arr[index].price = parseFloat(event);
      } else {
        this.appointment_arr[index].price = 0;
      }
      this.getTotal();
    },
    checkEmptyLine() {
      let checkEmptyLines = this.appointment_arr.filter(
        line => line.service === null
      );
      if (checkEmptyLines.length >= 1 && this.appointment_arr.length > 0) {
        return true;
      }
      return false;
    },
    addService() {
      if (this.checkEmptyLine()) return;
      this.appointment_arr.push({
        service: null,
        employee: null,
        price: 0,
        start_time: this.first_appointment.start_time,
        customer: this.first_appointment.customer
        // end_time: moment().format('HH:mm')
      });
      this.itemToShow = this.appointment_arr.length - 1;
    },
    getTotal() {
      let total = 0;
      for (let i = 0; i < this.appointment_arr.length; i++) {
        if (!isNaN(parseFloat(this.appointment_arr[i].price))) {
          total = total + parseFloat(this.appointment_arr[i].price);
        }
      }
      if (isNaN(total)) {
        this.current = 0;
      } else {
        this.current = total.toString();
      }
    },
    selectStaff(event, index) {
      this.appointment_arr[index].employee = event;
    },
    selectService(event, index) {
      this.appointment_arr[index].service = event;
      this.appointment_arr[index].price =
        this.appointment_arr[index].service.price != null
          ? parseFloat(this.appointment_arr[index].service.price)
          : 0;
      this.getTotal();
    },
    customFormatter(date) {
      return moment(date).format("dddd, DD MMM YYYY");
    },
    removeLine(index) {
      this.appointment_arr.splice(index, 1);
      this.getTotal();
    },
    saveNote() {
      // this.appointmentDetail.customer.note = this.note;
      // const obj = {
      //     id: this.appointmentDetail.customer.id,
      //     note: this.note
      // }
      // this.$store.dispatch('customer/UPDATE_CUSTOMER_NOTE', obj);
      // this.appointment_arr[0].note = this.note;
      for (let i = 0; i < this.appointment_arr.length; i++) {
        this.appointment_arr[i].customer.note = this.note;
      }
      // this.appointment_arr[0].customer.note = this.note;
      this.popupNote = false;
    },
    popupAddTip() {
      this.popupTip.isOpen = true;
    },
    // clearRadio() {
    //   document.getElementById("temp-radio-promo").click();
    // },
    // removeRedem(redem) {
    //   for (let i = 0; i < this.redemtion_list.length; i++) {
    //     if (this.redemtion_list[i].id == redem.id) {
    //       if (this.redemtion_list[i].checked) {
    //         this.$store.dispatch(
    //           "checkin/CHANGE_STATUS_REDEMPTION",
    //           this.redemtion_list[i]
    //         );
    //         this.redemtion_added = this.removeItemFromArray(
    //           this.redemtion_added,
    //           this.redemtion_list[i]
    //         );
    //         this.abc++;
    //         return;
    //       }
    //     }
    //   }
    // },
    // removeItemFromArray(arr, item) {
    //   for (let i = 0; i < arr.length; i++) {
    //     if (arr[i].id == item.id) {
    //       arr.splice(i, 1);
    //       return arr;
    //     }
    //   }
    // },
    // removePromo() {
    //   this.$store.dispatch(
    //     "checkin/CHANGE_STATUS_PROMOTION",
    //     this.promotion_added
    //   );
    //   (this.promotion_added = {}), this.clearRadio();
    // },
    changeStatus() {
      this.showInfo = !this.showInfo;
    },
    // addRedemtion(data) {
    //   if (data.checked == true) {
    //     this.redemtion_added.push(data);
    //   } else {
    //     for (let i = 0; i < this.redemtion_added.length; i++) {
    //       if (data.id == this.redemtion_added[i].id) {
    //         this.redemtion_added.splice(i, 1);
    //         return;
    //       }
    //     }
    //   }
    // },
    // changeStatusService() {
    //   this.popupService.isOpen = true;
    // },
    // addPromotion(data) {
    //   this.promotion_added = data;
    // },
    // popupPromotion() {
    //   this.popupConfigPromotion.isOpen = true;
    // },
    // popupRedemtion() {
    //   this.popupConfigRedemtion.isOpen = true;
    // },
    // clearPromotion() {
    //   for (let i = 0; i < this.promotion_list.length; i++) {
    //     if (this.promotion_list[i].checked) {
    //       this.$store.dispatch(
    //         "checkin/CHANGE_STATUS_PROMOTION",
    //         this.promotion_list[i]
    //       );
    //     }
    //   }
    // },
    closePopup() {
      this.popupConfig.isOpen = false;
      this.current = "";
    },
    reCalculator() {
      let amountCurrent = parseFloat(this.current);
      let promotion = 0;
      if (this.promotion_added.type == "percent") {
        promotion =
          (promotion + this.promotion_added.value / 100) * amountCurrent;
      } else if (this.promotion_added.type == "usd") {
        promotion = promotion + parseFloat(this.promotion_added.value);
      }
      let redemtion = 0;
      if (this.redemtion_added.length != 0) {
        for (let i = 0; i < this.redemtion_added.length; i++) {
          if (this.redemtion_added[i].checked == true) {
            redemtion = redemtion + parseFloat(this.redemtion_added[i].value);
          }
        }
      }
      if (amountCurrent <= redemtion + promotion) {
        return 0;
      } else {
        return amountCurrent - redemtion - promotion;
      }
    },
    append(number) {
      if (this.current.length <= 7) {
        if (this.operatorClicked) {
          this.current = "";
          this.operatorClicked = false;
        }
        if (this.current == "0" && number != ".") {
          this.current = "";
        }
        this.current = `${this.current}${number}`;
      }
    },
    dot() {
      if (this.current == "") {
        this.append("0");
      }
      if (this.current.indexOf(".") === -1) {
        this.append(".");
      }
    },
    deleteNum() {
      return (this.current = this.current.substring(
        0,
        this.current.length - 1
      ));
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46) ||
        (charCode == 46 && this.input_price.indexOf(".") != -1)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // changeStatusRadio(item) {
    //   for (let i = 0; i < this.promotion_list.length; i++) {
    //     if (this.promotion_list[i].checked) {
    //       // this.promotion_list[i].checked = false;
    //       this.$store.dispatch(
    //         "checkin/CHANGE_STATUS_PROMOTION",
    //         this.promotion_list[i]
    //       );
    //     }
    //   }
    //   for (let i = 0; i < this.promotion_list.length; i++) {
    //     if (this.promotion_list[i].id == item.id) {
    //       // this.promotion_list[i].checked = true;
    //       if (this.promotion_list[i].checked != true) {
    //         this.$store.dispatch(
    //           "checkin/CHANGE_STATUS_PROMOTION",
    //           this.promotion_list[i]
    //         );
    //       }
    //     }
    //   }
    // },
    getMemberTypeColor(member_type) {
      if (member_type == "new") return "success";
      if (member_type == "regular") return "primary";
      if (member_type == "vip") return "danger";
      return "dark";
    },
    checkout() {
      let data = {
        appointments: this.appointment_arr,
        price: this.current
      };
      this.$store.dispatch("appointment/CHECKOUT", data);
    }
  },
  computed: {
    services() {
      return this.$store.getters["service/list"];
    },
    staffs() {
      return this.$store.getters["staff/list"];
    }
    // staffData() {
    //   return this.$store.state.staffList.staffData;
    // },
    // serviceData() {
    //   return this.$store.state.serviceList.checkoutServiceData;
    // },
    // staffList() {
    //   return this.$store.state.staffList.staffList;
    // },
    // serviceList() {
    //   return this.$store.state.serviceList.checkoutService;
    // },
    // redemtion_list() {
    //   return this.$store.getters["checkin/redemptionList"];
    // },
    // promotion_list() {
    //   return this.$store.getters["checkin/promotionList"];
    // }
  }
};
</script>

<style lang="scss">
.custom-col {
  width: calc(100% / 3);
}

.con-vs-popup .vs-button {
  min-width: unset !important;
}

// @media (max-width: 991px) {
//     .custom-col {
//         width: 100%;
//     }
// }
.cal-button {
  width: 64px !important;
  height: 64px;
}
.list-enter,
.list-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.edit-icon {
  padding: 3px !important;
  border-radius: 50%;
  font-size: 18px;
}

.note {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 35px;
}

.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 70px);
  margin-right: auto;
  padding-left: 4px;
}

.theme-dark {
  .left-responsive {
    background: transparent !important;
  }
}

#appointment-checkout {
  // .con-vs-tabs {
  //     min-height: calc(100vh - 9rem);
  // }
  // .required-select {
  //     .feather-x {
  //     display: none;
  //     }
  // }
  .vs-input--icon {
    top: 11px;
  }
  .vs__dropdown-menu {
    height: 150px;
  }
  .customer-name {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 1rem 0.5rem 1.4rem 0rem;
  }
  .vs-input--input.hasIcon {
    padding: 0.7rem 1rem 0.7rem 2.5rem;
  }
  .vs-tabs {
    height: 100%;
  }
  .vs-tab {
    box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.4);
  }
  .vs-tabs--li {
    width: 25%;
  }

  .line-vs-tabs {
    width: 25% !important;
  }

  .con-slot-tabs {
    height: calc(100% - 37px);
    .vs-tabs--content {
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
